import type { TutorialAction, TutorialActionType } from '@/feature/tutorialAgent/tutorialAgentTypes'

const withActionMeta = (action: TutorialAction, extraMeta: Record<string, boolean>) => {
  return {
    ...action,
    meta: {
      ...(action.meta ?? {}),
      ...extraMeta
    }
  }
}

export const withGuidedControls = (action: TutorialAction): TutorialAction => {
  return withActionMeta(action, {
    showControls: true,
    hideControls: false
  })
}

export const withEditorWorkflowMeta = (action: TutorialAction): TutorialAction => {
  return withActionMeta(action, {
    showControls: true,
    hideControls: false,
    lockUi: true
  })
}

export const isEditorWorkflowLike = (actions: TutorialAction[]) => {
  return actions.some(action => {
    return [
      'insertDemoFile',
      'waitForEditorText',
      'waitForGeneratedOutput',
      'setFormats',
      'openInputSheet',
      'closeInputSheet'
    ].includes(action.type)
  })
}

export const flowIncludesNavigation = (actions: TutorialAction[]) => {
  return actions.some(action => action.type === 'navigate')
}

export const GUIDED_FLOW_PROMPT_WITH_NAVIGATION =
  'I can run this guided flow and navigate in the app. Start and allow both now?'
export const GUIDED_FLOW_PROMPT_WITHOUT_NAVIGATION =
  'I can run a guided on-screen flow for this. Start now?'
export const GUIDED_ACTIONS_UNSUPPORTED_MESSAGE =
  'I could not execute the suggested UI actions on this page yet, but I can still guide you step by step.'

export const getGuidedFlowConsentPrompt = (bundlesNavigationConsent: boolean): string => {
  return bundlesNavigationConsent
    ? GUIDED_FLOW_PROMPT_WITH_NAVIGATION
    : GUIDED_FLOW_PROMPT_WITHOUT_NAVIGATION
}

export const withBundledNavigationConsent = (actions: TutorialAction[]) => {
  return actions.map(action => {
    if (action.type !== 'navigate') return action
    return {
      ...action,
      meta: {
        ...(action.meta ?? {}),
        skipNavigationConsent: true
      }
    }
  })
}

export const SIDE_EFFECT_ACTION_TYPES = new Set<TutorialActionType>([
  'navigate',
  'scroll',
  'click',
  'openPanel',
  'openInputSheet',
  'closeInputSheet',
  'insertDemoFile',
  'waitForEditorText',
  'waitForGeneratedOutput',
  'setFormats'
])

export const REPLAY_SENSITIVE_SIDE_EFFECT_ACTION_TYPES = new Set<TutorialActionType>(
  Array.from(SIDE_EFFECT_ACTION_TYPES).filter(actionType => actionType !== 'scroll')
)
